<template>
  <v-container fluid class="upload-management mt-4 px-1">
    <v-row>
      <v-col cols="12">

        <v-card class="mb-1" v-if=" state=='index'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="7">
                  <v-file-input
                      v-model="editForm.uploads_url"
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      show-size
                      chips
                      placeholder="ไฟล์อัพโหลด"
                      prepend-icon="mdi-camera"
                      label="ไฟล์อัพโหลด"
                  ></v-file-input>
                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.uploads_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อไฟล์/หมายเหตุ"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>


              </v-row>


            </v-form>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการไฟล์อัพโหลด</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + uploads.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="uploads"
                :search="search"
                :options="options">

              <template v-slot:top>

              </template>

              <template v-slot:item.uploads_id="{ item }">

                <v-avatar tile v-if="(item.uploads_type).split('/')[0]=='image'">
                  <img
                      :src="baseURLStorage+item.uploads_url"
                      :alt="item.uploads_title_th+' '+item.uploads_type"
                  >
                </v-avatar>

                <v-avatar tile v-if="(item.uploads_type).split('/')[0]!='image'">
                  <img
                      :src="baseURLStorage+'/icon_extensions/'+item.uploads_extension+'.svg'"
                      :alt="item.uploads_title_th+' '+item.uploads_type"
                  >
                </v-avatar>


              </template>

              <template v-slot:item.uploads_title_th="{ item }">
                <a :href="baseURLStorage+item.uploads_url" target="_blank">
                  <span>{{ item.uploads_title_th }}</span>
                </a>

                <span><br>{{ dataFormatter.dateFormatterTH(item.updated_at, 1) }}</span>

              </template>


              <template v-slot:item.uploads_url="{ item }">


                <v-text-field
                    :label="baseURLStorage"
                    :value="item.uploads_url"
                    :append-outer-icon="'mdi-content-copy'"
                    type="text"
                    @click:append-outer="copyToClipBoard(baseURLStorage+item.uploads_url)"
                ></v-text-field>


              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <!--                <v-btn-->
                <!--                    class="mr-3 button-shadow"-->
                <!--                    @click="editItem(item)"-->
                <!--                    small-->
                <!--                    color="success"-->
                <!--                >แก้ไข-->
                <!--                </v-btn>-->

                <v-btn
                    class="mr-3 button-shadow"
                    @click="copyToClipBoard(baseURLStorage+item.uploads_url)"
                    small
                    color="success"
                >คัดลอก
                </v-btn>

                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>

              </template>
            </v-data-table>
          </v-card-text>


        </v-card>


      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="snackbar_copy"
        :timeout="2000"
    >
      <div v-html="text" class=""></div>

      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>


  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import dataFormatter from "@/use/dataFormatter";

export default {
  name: 'UploadManagement',
  data() {
    return {
      state: 'index',
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      snackbar_copy: null,
      search: '',
      selected: [],
      options: {
        sortBy: ['uploads_id'],
        sortDesc: [true]
      },
      headers: [
        {
          text: 'ไฟล์อัพโหลด',
          align: 'start',
          value: 'uploads_id',
        },

        {text: 'ชื่อไฟล์/หมายเหตุ', value: 'uploads_title_th'},
        {text: 'URL(ที่อยู่ของไฟล์)', value: 'uploads_url'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      upload_type_combo: [
        {v_value: 'Default', v_name: 'ค่าเริ่มต้น'},
        {v_value: 'Academic', v_name: 'ตำแหน่งทางวิชาการ'},
        {v_value: 'Rank', v_name: 'ยศ'},
        {v_value: 'Education', v_name: 'การศึกษา'},
      ],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(10),
        uploads_id: '',
        uploads_url: null,
        uploads_title_th: '',
        uploads_type: '',
        uploads_extension: '',
      },
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('uploads', ['uploads', "isReceiving", "isDeleting", "idToDelete", "uploadMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    uploadMessage() {

      if (this.uploadMessage !== '') {
        this.notification = this.uploadMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getUploadsRequest();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('uploads',
        [
          "getUploadsRequest",
          "deleteUploadRequest",
          "updateUploadRequest",
          "createUploadRequest"
        ]
    ),
    addItem() {


    },
    editItem(item) {
      console.log(item)

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteUploadRequest({uploads_id: item.uploads_id})


    },
    close() {

      if (this.errorMessage == false || this.uploadMessage == '') {
        this.state = "index";
        this.editedIndex = -1
        this.reset()
      }
    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.uploads[this.editedIndex], this.editForm)
            :
            this.updateUploadRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.uploads.push(this.editForm)
            :
            this.createUploadRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    displayText(item) {
      return (this.upload_type_combo.find(combobox => combobox.v_value === item)).v_name;

    },
    copyToClipBoard(textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      this.snackbar_copy = true;
      this.color = config.light.secondary;
      this.text = "คัดลอก " + textToCopy;

    },

  },
}
</script>

<style src="./UploadManagement.scss" lang="scss"/>
